import { createContext } from 'react';
/**
 * Storage for intent data
 */
export const intentContext = /*#__PURE__*/createContext({});